import Layout from '~/client/Layout'

export default Layout
